import React from 'react';
import classnames from 'classnames';
import './VerificationCodeInput.css';
import { isAlfa, isNumber } from '../../utils';
import { Box } from '../../flayr-components/Box/Box';
interface IVerificationCodeProps {
  value?: string;
  onChange?: (e: any) => void;
  onComplete?: (e?: any) => void;
  numberOfFields?: number;
  type?: 'text' | 'number';
  inputClassName?: string;
  clearInputOnFinish?: boolean;
  autoFocus?: boolean;
}

const VerificationCode: React.FC<React.PropsWithChildren<IVerificationCodeProps>> = ({
  value,
  onChange,
  onComplete,
  numberOfFields = 4,
  type = 'number',
  inputClassName = '',
  autoFocus,
  clearInputOnFinish,
}) => {
  const inputArray = Array.from(Array(numberOfFields).keys());
  const refs = React.useRef<any[]>([]);

  const [inputs, setInputs] = React.useState<number[] | string[]>(
    inputArray.map((n) => '')
  );

  React.useEffect(() => {
    if (value) {
      const inputs: number[] | string[] = value.toString().split('');
      const valueToSet = inputArray.map((idx) => inputs[idx] || '');
      setInputs(valueToSet);
    } else {
      setInputs(inputArray.map((n) => ''));
    }
  }, [value]);

  function handleChange(e) {
    const idx = +e.target.id;
    const inputValue = e.target.value;
    const newInput = inputs.slice();

    newInput[idx] = inputValue || '';
    const newInputJoined = newInput.join('');
    setInputs(newInput);
    onChange?.(newInputJoined);
    if (newInputJoined.length === numberOfFields) {
      clearInputOnFinish && setInputs(inputArray.map((n) => ''));
      return onComplete?.(newInputJoined);
    }
  }

  function handleKeyDown(e) {
    if ((type === 'number' && isNumber(e)) || (type === 'text' && isAlfa(e))) {
      const idx = +e.target.id;
      const inputValue = e.target.value;

      if (e.key === 'Backspace') {
        if (inputValue) {
          return;
        } else {
          return goToPrevInput(idx);
        }
      }
      goToNextInputField(idx);
    }
  }

  function goToNextInputField(idx) {
    idx = idx + 1;
    if (idx !== inputArray.length) {
      refs.current[idx].focus();
    }
  }

  function goToPrevInput(idx) {
    idx = idx - 1;
    if (idx >= 0) {
      refs.current[idx].focus();
    }
  }

  return (
    <div
      className={classnames('VerificationCodeInput grid gap-4 md:gap-6', {
        'grid-cols-4': numberOfFields === 4,
      })}
    >
      {inputArray.map((idx) => (
        <Box key={idx}>
          <input
            type={type}
            id={`${idx}`}
            value={inputs[idx] || ''}
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            className={`${inputClassName} shadow absolute top-0 left-0 w-full h-full rounded text-center bg-gray-100 md:bg-white focus:outline-none border border-gray-100 focus:border-primary-1 text-2xl`}
            ref={(el) => (refs.current[idx] = el)}
            autoFocus={autoFocus && idx === 0}
          />
        </Box>
      ))}
    </div>
  );
};
export default VerificationCode;
